var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 496H16V376H496V496Z",
    fill: "#2ECC71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 376H16V256H496V376Z",
    fill: "#F1C40F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 256H16V136H496V256Z",
    fill: "#2B4896"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 136H16V16H496V136Z",
    fill: "#E32D3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMu);
export default __webpack_public_path__ + "static/media/MU.41573a9c3ae8e6c21fb4d3105c0c1e90.svg";
export { ForwardRef as ReactComponent };